"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkErrorSetter = exports.useNetworkContext = exports.NetworkContext = void 0;
exports.NetworkContextProvider = NetworkContextProvider;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const netinfo_1 = __importDefault(require("@react-native-community/netinfo"));
const react_native_1 = require("react-native");
exports.NetworkContext = react_1.default.createContext({
    networkError: false,
    setNetworkError: (error) => { }
});
function NetworkContextProvider(props) {
    const [networkError, setNetworkError] = (0, react_1.useState)(false);
    react_1.default.useEffect(() => {
        exports.NetworkErrorSetter.set(setNetworkError);
        let unsubscribe;
        if (react_native_1.Platform.OS !== 'web') {
            unsubscribe = netinfo_1.default.addEventListener(state => {
                setNetworkError(!state.isConnected);
            });
        }
        else {
            const updateOnlineStatus = () => setNetworkError(!navigator.onLine);
            window.addEventListener('online', updateOnlineStatus);
            window.addEventListener('offline', updateOnlineStatus);
            updateOnlineStatus();
            unsubscribe = () => {
                window.removeEventListener('online', updateOnlineStatus);
                window.removeEventListener('offline', updateOnlineStatus);
            };
        }
        return () => {
            if (unsubscribe)
                unsubscribe();
        };
    }, [setNetworkError]);
    return ((0, jsx_runtime_1.jsx)(exports.NetworkContext.Provider, { value: {
            networkError,
            setNetworkError
        }, children: props.children }));
}
;
const useNetworkContext = () => react_1.default.useContext(exports.NetworkContext);
exports.useNetworkContext = useNetworkContext;
// Export setter for use outside components
let externalSetNetworkError = (error) => { };
exports.NetworkErrorSetter = {
    set: (fn) => { externalSetNetworkError = fn; },
    trigger: (error) => externalSetNetworkError(error),
};
